// extracted by mini-css-extract-plugin
export var csatScore = "_lg-5";
export var header = "_lg-1";
export var panelWrapper = "_lg-2";
export var postPreview = "_lg-3";
export var rightContent = "_lg-0";
export var wrappingText = "_lg-4";